import { render, staticRenderFns } from "./ProfileLeft.vue?vue&type=template&id=35577342&scoped=true"
import script from "./ProfileLeft.vue?vue&type=script&lang=ts"
export * from "./ProfileLeft.vue?vue&type=script&lang=ts"
import style0 from "./ProfileLeft.vue?vue&type=style&index=0&id=35577342&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35577342",
  null
  
)

export default component.exports